module.exports = __webpack_public_path__ + "static/img/Dream-11.061a9f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Dream House/Dream-11.jpg
// module id = tDBv
// module chunks = 7